import gql from "graphql-tag";

export const MY_HR_CONTRACTS_SUBSCRIPTION = gql`
  subscription contractsSubscription {
    contractsSubscription
  }
`;
